<template>
  <div class="order" v-cloak>
    <el-row type="flex" justify="between" :gutter="5">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <userCard
            :config="cardConfig"
            @clear-job="clearJob"
            @saveSuccess="getData()"
          ></userCard>
        </div>
      </el-col>
    </el-row>
    <div class="order-solution">
      <div class="os-list">
        <div class="os-title">
          <el-row :gutter="40">
            <el-col :span="18">
              <div class="left flex-between">
                <div class="title-control flex-between">
                  <i class="el-icon-tickets"></i>
                </div>
                <p class="title">
                  {{ $lange == "en" ? "Request Detail" : "详情" }}
                </p>
                <span></span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="right flex-between">
                <span></span>
                <!--                                <el-button type="primary" size="mini"></el-button>-->
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="order-content">
          <div class="content-top">
            <div class="excelData flex-between" v-if="orderData.status">
              <p>
                {{ $lange == "en" ? "Order" : "工单" }}ID:
                {{ (!isCreate && orderId) || "---" }}
              </p>
              <p>
                {{ $lange == "en" ? "Create Time" : "申请时间" }}:
                {{ (!isCreate && orderData.createTime) || "---" }}
              </p>
              <!--                            <p>{{$lange=='en' ? 'Type' : '工单类型'}}: {{!isCreate && orderTypeOptions[orderData.type] || "-&#45;&#45;"}}</p>-->
              <p v-if="$lange == 'zh'">
                {{ $lange == "en" ? "Product status" : "产品状态" }}:
                {{
                  (!isCreate && productStatus[orderData.product.status]) ||
                  "---"
                }}
              </p>
              <p v-if="$lange == 'en'">
                {{ $lange == "en" ? "Product status" : "产品状态" }}:
                {{
                  (!isCreate && productStatusEN[orderData.product.status]) ||
                  "---"
                }}
              </p>
              <!--                            <p>{{$lange=='en' ? 'Status' : '状态'}}: {{ !isCreate && orderData && orderStatus && orderStatus[orderData.status].title || "-&#45;&#45;" }}</p>-->
              <p>
                {{ $lange == "en" ? "Status" : "状态" }}:
                {{ orderStatusFilter }}
              </p>
              <template v-if="!isCreate && isHandle">
                <p
                  class="btn-group flex-between"
                  v-if="!cardConfig.isOrderEdit"
                >
                  <el-button size="mini" type="primary" @click="editOrder">{{
                    $lange == "en" ? "Edit" : "编辑"
                  }}</el-button>
                </p>
                <p class="btn-group flex-between" v-else>
                  <el-button size="mini" @click="cancelEdit">{{
                    $lange == "en" ? "Cancel" : "取消"
                  }}</el-button>
                  <el-button size="mini" type="primary" @click="orderSave">{{
                    $lange == "en" ? "Save" : "保存"
                  }}</el-button>
                </p>
              </template>
            </div>
            <div class="excelData flex-between">
              <template v-if="!cardConfig.isOrderEdit">
                <p>Job ID: {{ orderData.jobId || "---" }}</p>
                <p v-if="$lange == 'zh'">
                  {{ $lange == "en" ? "Machine" : "机器" }}:
                  {{ orderData.machine.machineModel || "---" }}
                </p>
                <p v-if="$lange == 'en'">
                  {{ $lange == "en" ? "Machine" : "机器" }}:
                  {{
                    orderData.machine.machineEnModel
                      ? orderData.machine.machineEnModel
                      : orderData.machine.machineModel || "---"
                  }}
                </p>
                <p>
                  {{ $lange == "en" ? "Abbr" : "缩写" }}:
                  {{ orderData.machine.machineAbbr || "---" }}
                </p>
                <p>COM No: {{ orderData.machine.fiCom || "---" }}</p>
              </template>
              <template v-else>
                <p class="require-class require-class2">
                  Job ID:
                  <span style="display: inline-block">
                    <el-select
                      size="mini"
                      placeholder="Job ID"
                      @change="jobIdChange"
                      v-model="orderData.jobId"
                    >
                      <el-option
                        v-for="item in jobIdArr"
                        :label="item.jobId"
                        :value="item.jobId"
                        :key="item.jobId"
                      ></el-option>
                    </el-select>
                  </span>
                </p>
                <p class="require-class require-class2">
                  {{ $lange == "en" ? "Machine" : "机器" }}:
                  <span style="display: inline-block" :key="orderData.jobId">
                    <cc-selector
                      :config="machineSelectorConfig"
                      :value="orderData.machine.id"
                      :placeholder="
                        $lange == 'en' ? 'Please Select Machine' : '请选择机器'
                      "
                      @change="machineChange"
                    />
                  </span>
                </p>

                <p>
                  {{ $lange == "en" ? "Abbr" : "缩写" }}:
                  {{ orderData.machine.machineAbbr || "---" }}
                </p>
                <p>COM No: {{ orderData.machine.fiCom || "---" }}</p>
              </template>
            </div>
            <div class="excelData flex-between">
              <template v-if="!cardConfig.isOrderEdit">
                <p>
                  {{ $lange == "en" ? "Contacts" : "申请人" }}:
                  {{ orderData.userName || "---" }}
                </p>
                <p>
                  {{ $lange == "en" ? "Moblie No." : "联系方式" }}:
                  {{ orderData.phone || "---" }}
                </p>
              </template>
              <template v-else>
                <p class="require-class require-class2">
                  {{ $lange == "en" ? "Contacts" : "申请人" }}:
                  <span style="display: inline-block">
                    <el-select
                      v-model="orderData.userId"
                      size="mini"
                      :placeholder="
                        $lange == 'en'
                          ? 'Please Select Contacts'
                          : '请选择申请人'
                      "
                      clearable
                      @change="contactChange"
                    >
                      <el-option
                        v-for="op in contactSelector"
                        :label="op.userName"
                        :value="op.userId"
                        :key="op.userId"
                      ></el-option>
                    </el-select>
                  </span>
                </p>
                <p>
                  {{ $lange == "en" ? "MoblieNo." : "联系方式" }}:
                  {{ orderData.phone || "---" }}
                </p>
              </template>

              <span></span>
              <span></span>
            </div>
          </div>
          <div class="content-bottom">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="left">
                  <div>
                    <span>{{ $lange == "en" ? "Subject" : "问题标题" }}:</span>
                    <div>
                      <template v-if="cardConfig.isOrderEdit">
                        <el-input
                          :placeholder="
                            $lange == 'en'
                              ? 'Please Enter Subject'
                              : '请输入问题标题'
                          "
                          size="mini"
                          v-model="orderData.title"
                        ></el-input>
                      </template>
                      <template v-else>{{ orderData.title }}</template>
                    </div>
                  </div>
                  <div>
                    <span
                      >{{ $lange == "en" ? "Description" : "问题描述" }}:</span
                    >
                    <div>
                      <template v-if="cardConfig.isOrderEdit">
                        <el-input
                          :placeholder="
                            $lange == 'en'
                              ? 'Please Enter  Description'
                              : '请输入问题描述'
                          "
                          size="mini"
                          type="textarea"
                          :rows="4"
                          v-model="orderData.description"
                        ></el-input>
                      </template>
                      <template v-else>{{ orderData.description }}</template>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="right">
                  <span>{{ $lange == "en" ? "Images" : "图片" }}:</span>
                  <div class="image-lists flex-between">
                    <div
                      class="list"
                      v-for="(item, ind) in postForm.accessoryInfoList"
                      @click="showImage(item.accessoryUrl)"
                      :style="
                        'background:url(' +
                        item.accessoryUrl +
                        ') no-repeat center / cover'
                      "
                    >
                      <div
                        class="del-image flex-between"
                        v-if="cardConfig.isOrderEdit"
                        @click.stop="deleteImage(ind)"
                      >
                        X
                      </div>
                    </div>
                    <div
                      class="list order-upload-image"
                      v-if="cardConfig.isOrderEdit"
                    >
                      <cc-uploader
                        :config="uploaderConf2"
                        uploadType="dottedLine"
                        @upload-success="uploadTrue"
                        :isMultiple="true"
                      />
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="create-btn flex-between">
          <template v-if="isCreate">
            <div style="padding-bottom: 20px">
              <el-button size="mini" @click="cancelEdit">{{
                $lange == "en" ? "Cancel" : "取消"
              }}</el-button>
              <el-button size="mini" type="primary" @click="orderSave">{{
                $lange == "en" ? "Create" : "创建"
              }}</el-button>
            </div>
          </template>
          <template v-else>
            <div class="history-msg flex-between">
              <p>{{ $lange == "en" ? "History" : "历史沟通消息" }}</p>
              <el-button size="mini" @click="historyShow = !historyShow">{{
                $lange == "en" ? "View" : "展开"
              }}</el-button>
            </div>
            <el-collapse-transition>
              <div class="history-lists" v-show="historyShow">
                <div class="list-border">
                  <div class="list" v-for="(item, index) in historyData">
                    <i class="left-icon"></i>
                    <p>{{ item.createTime }}</p>
                    <p class="user-msg">
                      {{
                        item.isAdmin == 1
                          ? item.handlerName
                          : orderData.customer.customerName
                      }}{{ $lange == "en" ? ":" : "回复" }}
                    </p>
                    <div class="msg-context">
                      <div class="top">
                        <p class="title-text">
                          {{ $lange == "en" ? "Problem reply" : "问题回复" }}
                        </p>
                        <div
                          class="text html-context"
                          v-html="item.replyContent"
                        >
                          {{ item.replyContent }}
                        </div>
                      </div>
                      <div class="bottom flex-between">
                        <div class="left">
                          <p class="title-text">
                            {{
                              $lange == "en"
                                ? "Accessories Service"
                                : "配件服务"
                            }}
                          </p>
                          <template
                            v-if="item.handleType == 1 || item.handleType == 3"
                          >
                            <template v-if="item.partsOrder">
                              <div
                                class="text-list flex-between"
                                v-for="(pItem, pIndex) in item.partsOrder
                                  .partsOrderLogList"
                              >
                                <div class="text-left">
                                  {{ pItem.parts.partsName }}
                                </div>
                                <div class="text-right">
                                  {{ $lange == "en" ? "Number" : "数量" }}
                                  {{ pItem.partsNum }}
                                </div>
                              </div>
                            </template>
                          </template>
                        </div>

                        <div class="right">
                          <p class="title-text">
                            {{ $lange == "en" ? "Field Service" : "外派服务" }}
                          </p>
                          <template
                            v-if="item.handleType == 2 || item.handleType == 3"
                          >
                            <div class="text-list flex-between">
                              <div class="text-left">
                                {{
                                  $lange == "en"
                                    ? "Estimated number of people"
                                    : "预估人数"
                                }}
                              </div>
                              <div
                                class="text-right"
                                v-if="item.expatriateOrder"
                              >
                                {{ item.expatriateOrder.peopleNum }} 人
                              </div>
                            </div>
                            <div class="text-list flex-between">
                              <div class="text-left">
                                {{
                                  $lange == "en"
                                    ? "Estimated working hours"
                                    : "预计工时"
                                }}
                              </div>
                              <div
                                class="text-right"
                                v-if="item.expatriateOrder"
                              >
                                {{ item.expatriateOrder.workHour }} 小时
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </template>
        </div>
      </div>
      <template v-if="!isCreate">
        <div class="os-list">
          <div class="os-title">
            <el-row :gutter="40">
              <el-col :span="18">
                <div class="left flex-between">
                  <div
                    class="title-control flex-between"
                    @click="showHandleData = !showHandleData"
                  >
                    <i class="el-icon-arrow-up" v-if="!showHandleData"></i>
                    <i class="el-icon-arrow-down" v-else></i>
                  </div>
                  <p class="title">
                    {{ $lange == "en" ? "Request Processing" : "工单处理方案" }}
                  </p>
                  <span v-if="$lange == 'en'"
                    >Status:
                    {{ finishType[orderData.schemeList[0].isFinish] }}</span
                  >
                  <span v-if="$lange != 'en'"
                    >状态:
                    {{ finishTypeV2[orderData.schemeList[0].isFinish] }}</span
                  >
                  <span v-if="showHandleData"
                    >{{ $lange == "en" ? "Responsible" : "当前处理人" }}:
                    {{ orderData.handlerName }}</span
                  >
                </div>
              </el-col>
              <el-col :span="6">
                <div class="right flex-between">
                  <template v-if="showHandleData">
                    <template
                      v-if="isHandle && orderData.schemeList[0].isConfirm !== 1"
                    >
                      <span>
                        {{ $lange == "en" ? "Transfer to" : "工单转移" }}:
                        <span style="display: inline-block">
                          <el-select
                            size="mini"
                            v-model="engineerId"
                            @change="engineerChange"
                            :placeholder="
                              $lange == 'en' ? 'Select employee' : '请选择'
                            "
                          >
                            <el-option
                              v-for="item in engineerSelectorList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </span>
                      </span>
                      <el-button
                        type="primary"
                        size="mini"
                        @click="turnEngineer"
                        >{{ $lange == "en" ? "Transfer" : "转移" }}</el-button
                      >
                    </template>
                  </template>
                  <template v-else>
                    <span></span>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="showHandleData = true"
                      >{{ $lange == "en" ? "View Detail" : "查看" }}</el-button
                    >
                  </template>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-collapse-transition>
            <div class="os-content" v-show="showHandleData">
              <div class="select-box">
                <div style="display: inline-block">
                  <el-select
                    v-model="orderData.priority"
                    @change="priorityChange"
                    :disabled="
                      !isHandle || userData.roleTips == 'accessoriesSpecialist'
                    "
                    size="mini"
                    :placeholder="$lange == 'en' ? 'Priority' : '优先级'"
                  >
                    <el-option
                      :label="$lange == 'en' ? 'Low' : '低'"
                      value="低"
                    ></el-option>
                    <el-option
                      :label="$lange == 'en' ? 'Middle' : '中'"
                      value="中"
                    ></el-option>
                    <el-option
                      :label="$lange == 'en' ? 'High' : '高'"
                      value="高"
                    ></el-option>
                  </el-select>
                </div>

                <!--                                <div style="display: inline-block;max-width: 250px;">-->
                <!--                                    2019.12.13 客户提出去掉-->
                <!--                                    <cc-selector :config="machineSelectorConfig"-->
                <!--                                                 :value="orderData.machine.id"-->
                <!--                                                 :placeholder="$lange=='en' ? 'Machine Association' : '机器关联'"-->
                <!--                                                 @change="machineChange2"/>-->
                <!--                                </div>-->

                <div style="display: inline-block">
                  <el-select
                    v-model="orderData.requestType"
                    size="mini"
                    @change="workTypeChange"
                    :disabled="
                      !isHandle || userData.roleTips == 'accessoriesSpecialist'
                    "
                    placeholder="请求类型"
                  >
                    <el-option
                      :label="
                        $lange == 'en' ? 'Information Inquiry' : '一般咨询'
                      "
                      :value="0"
                    ></el-option>
                    <el-option
                      :label="$lange == 'en' ? 'Spare Part Order' : '配件申请'"
                      :value="1"
                    ></el-option>
                    <el-option
                      :label="$lange == 'en' ? 'Machine Failures' : '问题故障'"
                      :value="2"
                    ></el-option>
                  </el-select>
                </div>
                <!--                        <template v-if="handleData.orderType == 2">-->
                <template v-if="orderData.requestType == 2">
                  <div style="display: inline-block">
                    <!--                                        <cc-selector :config="malfunctionSelectorConfig"-->
                    <!--                                                     :value="orderData.malfunctionAttribute.name"-->
                    <!--                                                     placeholder="故障分类"-->
                    <!--                                                     @change="malfunctionChange"-->
                    <!--                                        />-->
                    <cc-selector
                      :config="malfunctionSelectorConfig"
                      v-model="handleData.malfunctionId"
                      :placeholder="
                        $lange == 'en' ? 'Fault classification' : '故障分类'
                      "
                      @change="malfunctionChange"
                    />
                  </div>
                  <div style="display: inline-block">
                    <!--                                        <cc-selector :config="problemSelectorConfig"-->
                    <!--                                                     :value="orderData.problemAttribute.name"-->
                    <!--                                                     placeholder="问题来源"-->
                    <!--                                                     @change="problemChange"-->
                    <!--                                        />-->
                    <cc-selector
                      :config="problemSelectorConfig"
                      v-model="handleData.problemId"
                      @change="problemChange"
                      :placeholder="
                        $lange == 'en' ? 'Source of the issue' : '问题来源'
                      "
                    />
                  </div>
                </template>
              </div>
              <div class="os-con-list engineer-remark flex-between">
                <p class="title">
                  {{ $lange == "en" ? "Comments" : "工程师备注" }}:
                </p>
                <div class="remark-lists">
                  <template v-for="item in orderData.extraData">
                    <div class="list">
                      <span>--{{ item.remark }}</span>
                      <span>---{{ item.adminName }} {{ item.createTime }}</span>
                    </div>
                  </template>
                </div>
                <el-button
                  v-if="isHandle"
                  size="mini"
                  icon="el-icon-plus"
                  @click="addRemark = true"
                  >{{ $lange == "en" ? "Add remark" : "添加备注" }}</el-button
                >
              </div>
              <div class="os-con-list engineer-remark flex-between">
                <p class="title">
                  {{ $lange == "en" ? "Solution" : "解决方案" }}:
                </p>
                <div class="remark-lists">
                  <template
                    v-if="
                      isHandle && userData.roleTips != 'accessoriesSpecialist'
                    "
                  >
                    <cc-editor v-model="handleData.replyContent"></cc-editor>
                    <div>
                      <el-button size="mini" @click="temporaryStorage">{{
                        $lange == "en" ? "Save temporary" : "暂存解决方案"
                      }}</el-button>
                    </div>
                  </template>

                  <div
                    v-else
                    class="html-context"
                    v-html="handleData.replyContent"
                  >
                    {{ handleData.replyContent }}
                  </div>
                </div>
              </div>

              <div
                class="os-con-list switch-btn flex-between"
                style="margin-top: 30px"
              >
                <div class="switch-btn flex-between" style="margin-right: 60px">
                  <p class="title" style="margin-bottom: 0">
                    {{ $lange == "en" ? "Payment (Yes/No):" : "是否收费:" }}
                    <el-select
                      v-model="orderData.isUnderWarranty"
                      style="max-width: 100px"
                      @change="isUnderWarrantyChange"
                      v-if="isHandle && userData.roleTips == 'technicalSupport'"
                      size="mini"
                      :placeholder="$lange == 'en' ? 'Type' : '状态'"
                    >
                      <el-option
                        :label="$lange == 'en' ? 'No' : '免费'"
                        :value="0"
                      ></el-option>
                      <el-option
                        :label="$lange == 'en' ? 'Yes' : '收费'"
                        :value="1"
                      ></el-option>
                    </el-select>
                    <span v-else>
                      <template v-if="$lange === 'en'">{{
                        ["No", "Yes"][orderData.isUnderWarranty]
                      }}</template>
                      <template v-else>{{
                        ["免费", "收费"][orderData.isUnderWarranty]
                      }}</template>
                    </span>
                  </p>
                </div>
                <div class="switch-btn flex-between">
                  <p class="title">
                    {{ $lange == "en" ? "Spare Part (Yes/No)" : "配件服务" }}:
                  </p>
                  <el-switch
                    v-model="handleData.isParts"
                    :disabled="
                      !isHandle || userData.roleTips == 'accessoriesSpecialist'
                    "
                    size="mini"
                  ></el-switch>
                </div>
                <div
                  class="switch-btn flex-between"
                  style="margin-left: 60px"
                  v-if="orderData.type != 0"
                >
                  <p class="title">
                    {{
                      $lange == "en" ? "Field Service (Yes/No)" : "外派服务"
                    }}:
                  </p>
                  <el-switch
                    v-model="handleData.isExpatriate"
                    :disabled="
                      !isHandle || userData.roleTips == 'accessoriesSpecialist'
                    "
                    size="mini"
                  ></el-switch>
                </div>
                <div
                  class="switch-btn flex-between"
                  style="margin-left: 60px"
                  v-if="
                    (handleData.isExpatriate || handleData.isParts) &&
                    orderData.isUnderWarranty === 0 &&
                    totalFee < 0.01
                  "
                >
                  <p class="title">
                    {{
                      $lange == "en" ? "Quotation (Yes/No)" : "无需确认方案"
                    }}:
                  </p>
                  <el-switch
                    v-model="handleData.notConfirm"
                    :disabled="
                      !isHandle ||
                      orderData.schemeList[0].status !== 0 ||
                      orderData.schemeList[0].isConfirm === 1
                    "
                    size="mini"
                  ></el-switch>
                </div>

                <div
                  class="switch-btn flex-between"
                  v-if="handleData.isParts || handleData.isExpatriate"
                  style="margin-left: 60px"
                >
                  <p class="title" style="line-height: 26px">
                    {{ $lange == "en" ? "Auditor" : "审核人员" }}:
                    {{
                      !isHandle || orderData.schemeList[0].isConfirm === 1
                        ? orderData.handlerName
                        : ""
                    }}
                  </p>
                  <cc-selector
                    style="width: 130px"
                    :config="handlerSelectorConfig"
                    :placeholder="
                      $lange == 'en'
                        ? 'Commercial Commissioner'
                        : '请选择商务专员'
                    "
                    v-model="orderData.handlerId"
                    v-if="orderData.schemeList[0].isConfirm !== 1 && isHandle"
                  />
                </div>
              </div>

              <template v-if="handleData.isExpatriate || handleData.isParts">
                <div class="os-con-list machine-order">
                  <template v-if="handleData.isParts">
                    <div class="title">
                      {{ $lange == "en" ? "Spare Parts List" : "订单配件列表" }}
                      <el-button
                        v-if="
                          isHandle && orderData.schemeList[0].isConfirm !== 1
                        "
                        class="btn-add-machine"
                        icon="el-icon-plus"
                        size="mini"
                        @click="addPartsFlag = true"
                        >{{
                          $lange == "en" ? "Spare Part List" : "添加配件"
                        }}</el-button
                      >
                      <!--                                    <el-checkbox v-model="handleData.sendProblemParts" :disabled="!isHandle" class="btn-need"> 需要寄回问题件-->
                      <!--                                    </el-checkbox>-->
                    </div>
                    <div class="table-box not-padding">
                      <cc-table
                        :config="partsTableConfig"
                        :data-arr="
                          orderData.schemeList[0].workOrderLogList[0].partsOrder
                            .partsOrderLogList
                        "
                        :load-data="partsTableLoad"
                      ></cc-table>
                    </div>
                    <div class="total-context flex-between">
                      <div class="total-msg">
                        {{ $lange == "en" ? "Total" : "总计" }}: ￥{{
                          totalFee
                        }}
                      </div>
                      <div class="pay-type">
                        {{ $lange == "en" ? "Payment method" : "支付方式" }}:
                        <template v-if="totalFee < 0.01">
                          <span>{{
                            $lange == "en" ? "Free Admission" : "免费"
                          }}</span>
                        </template>
                        <template v-else>
                          <el-radio-group
                            v-model="
                              orderData.schemeList[0].workOrderLogList[0]
                                .partsOrder.payment
                            "
                            v-if="
                              isHandle &&
                              orderData.schemeList[0].isConfirm !== 1
                            "
                          >
                            <el-radio :label="0">{{
                              $lange == "en" ? "Monthly fee" : "费用月结"
                            }}</el-radio>
                            <el-radio :label="1">{{
                              $lange == "en"
                                ? "Delivery after payment"
                                : "付款后发货"
                            }}</el-radio>
                          </el-radio-group>
                          <span v-else>
                            <template v-if="$lange == 'en'">{{
                              ["Monthly fee", "Delivery after payment"][
                                orderData.schemeList[0].workOrderLogList[0]
                                  .partsOrder.payment
                              ]
                            }}</template>
                            <template v-else>{{
                              ["费用月结", "付款后发货"][
                                orderData.schemeList[0].workOrderLogList[0]
                                  .partsOrder.payment
                              ]
                            }}</template>
                          </span>
                        </template>
                      </div>
                      <div class="file-upload">
                        {{ $lange == "en" ? "Attachment" : "附件" }}:
                        <span
                          v-if="
                            orderData.schemeList[0].workOrderLogList[0]
                              .partsOrder.accessoryInfoList != ''
                          "
                          @click="
                            downloadFile(
                              orderData.schemeList[0].workOrderLogList[0]
                                .partsOrder.accessoryInfoList[0],
                              '配件清单'
                            )
                          "
                          class="download-file"
                          >{{
                            orderData.schemeList[0].workOrderLogList[0]
                              .partsOrder.accessoryInfoList[0].fileName
                          }}</span
                        >
                        <el-button
                          size="mini"
                          v-if="
                            isHandle && orderData.schemeList[0].isConfirm !== 1
                          "
                          style="margin-left: 10px"
                          type="primary"
                          @click="showUploadPartsFile = true"
                          >{{
                            $lange == "en" ? "Upload Attachment" : "添加附件"
                          }}</el-button
                        >
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  class="os-con-list expatriate-context flex-between"
                  v-if="orderData.type != 0"
                >
                  <template v-if="handleData.isExpatriate">
                    <p class="title">
                      {{ $lange == "en" ? "Field Service" : "外派服务" }}:
                    </p>
                    <p>
                      {{ $lange == "en" ? "Need Payment" : "费用类型" }}:
                      <template v-if="$lange == 'en'">{{
                        orderData.isUnderWarranty == 1 ? "Yes" : "No"
                      }}</template>
                      <template v-else>{{
                        orderData.isUnderWarranty == 1 ? "收费" : "免费"
                      }}</template>
                    </p>
                    <p>
                      {{ $lange == "en" ? "Attachment" : "附件" }}:
                      <span
                        class="download-file row-clip"
                        style="display: inline-block; max-width: 120px"
                        v-if="
                          orderData.schemeList[0].workOrderLogList[0]
                            .expatriateOrder.serviceInvitation
                        "
                        @click="
                          downloadFile(
                            orderData.schemeList[0].workOrderLogList[0]
                              .expatriateOrder.serviceInvitation,
                            '服务邀请函'
                          )
                        "
                        >{{
                          orderData.schemeList[0].workOrderLogList[0]
                            .expatriateOrder.serviceInvitation.fileName
                        }}</span
                      >
                      <span v-if="orderData.schemeList[0].isConfirm !== 1">
                        <el-button
                          @click="showUploadInviteFile = true"
                          size="mini"
                          v-if="isHandle"
                          >{{
                            $lange == "en" ? "Re upload" : "重新上传"
                          }}</el-button
                        >
                      </span>
                    </p>
                    <p>
                      {{
                        $lange == "en"
                          ? "Estimated number of people"
                          : "预估人数"
                      }}
                      <span style="max-width: 80px">
                        <el-input
                          size="mini"
                          v-model.number="
                            orderData.schemeList[0].workOrderLogList[0]
                              .expatriateOrder.peopleNum
                          "
                          v-if="
                            isHandle && orderData.schemeList[0].isConfirm !== 1
                          "
                        ></el-input>
                        <span v-else>{{
                          orderData.schemeList[0].workOrderLogList[0]
                            .expatriateOrder.peopleNum
                        }}</span>
                      </span>
                      {{ $lange == "en" ? "" : "人" }}
                    </p>
                    <p>
                      {{
                        $lange == "en" ? "Estimated working hours" : "预计工时"
                      }}
                      <span style="max-width: 80px">
                        <el-input
                          size="mini"
                          v-model.number="
                            orderData.schemeList[0].workOrderLogList[0]
                              .expatriateOrder.workHour
                          "
                          v-if="
                            isHandle && orderData.schemeList[0].isConfirm !== 1
                          "
                        ></el-input>
                        <span v-else>{{
                          orderData.schemeList[0].workOrderLogList[0]
                            .expatriateOrder.workHour
                        }}</span>
                      </span>
                      {{ $lange == "en" ? "" : "小时" }}
                    </p>
                    <p>
                      {{ $lange == "en" ? "Responsible" : "负责人" }}
                      <span style="max-width: 200px">
                        <!--                                             <el-select-->
                        <!--                                                     v-model="orderData.schemeList[0].workOrderLogList[0].expatriateOrder.handlerId"-->
                        <!--                                                     v-if="isHandle && (orderData.schemeList[0].isConfirm !== 1)"-->
                        <!--                                                     size="mini" :placeholder="$lange=='en' ? 'Please select the person in charge' : '请选择负责人'">-->
                        <!--                                                <el-option-->
                        <!--                                                    v-for="op in principalSelector"-->
                        <!--                                                    :label="`${op.name} (${op.roleName})`"-->
                        <!--                                                    :value="op.id"-->
                        <!--                                                    :key="op.id"-->
                        <!--                                                ></el-option>-->
                        <!--                                             </el-select>-->
                        <span
                          v-if="
                            orderData.schemeList[0].workOrderLogList[0]
                              .expatriateOrder.handlerId
                          "
                          >{{
                            orderData.schemeList[0].workOrderLogList[0]
                              .expatriateOrder.handlerName
                          }}</span
                        >
                        <span v-else>{{ userData.name }}</span>
                      </span>
                    </p>
                  </template>
                </div>
              </template>
              <div
                class="os-con-list submit-btn flex-between"
                v-if="
                  isHandle &&
                  orderData.schemeList[0].status === 0 &&
                  orderData.schemeList[0].isConfirm !== 1
                "
              >
                <p></p>
                <el-button size="mini" type="primary" @click="saveWorkOrder">{{
                  $lange == "en" ? "Submit" : "提交"
                }}</el-button>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <div
          class="os-list"
          v-if="
            orderData.schemeList[0].isCheck !== 10 &&
            (totalFee > 0 || orderData.isUnderWarranty == 1)
          "
        >
          <div class="os-title">
            <el-row :gutter="40">
              <el-col :span="18">
                <div class="left flex-between">
                  <div class="title-control flex-between" style="opacity: 0">
                    <i class="el-icon-arrow-up"></i>
                  </div>
                  <p class="title">
                    {{
                      $lange == "en"
                        ? "Verify receipt and payment"
                        : "核实收付款"
                    }}
                  </p>
                  <span v-if="$lange == 'en'"
                    >Status:
                    {{
                      orderData.schemeList[0].isCheck === 0
                        ? "To be audited"
                        : "Audited"
                    }}</span
                  >
                  <span v-else
                    >状态:
                    {{
                      orderData.schemeList[0].isCheck === 0
                        ? "待审核"
                        : "已审核"
                    }}</span
                  >
                </div>
              </el-col>
              <el-col :span="6">
                <div class="right flex-between">
                  <span></span>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="changeActiveName"
                    >{{ $lange == "en" ? "View Detail" : "查看" }}</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          class="os-list"
          v-if="orderData.schemeList[0].partsOrderStatus !== 10"
        >
          <div class="os-title">
            <el-row :gutter="40">
              <el-col :span="18">
                <div class="left flex-between">
                  <div class="title-control flex-between" style="opacity: 0">
                    <i class="el-icon-arrow-up"></i>
                  </div>
                  <p class="title">
                    {{ $lange == "en" ? "Spare Parts Delivery" : "配件发货" }}
                  </p>
                  <span v-if="$lange == 'en'"
                    >Status:
                    {{
                      ["processing", "completed"][
                        orderData.schemeList[0].partsOrderStatus
                      ]
                    }}</span
                  >
                  <span v-else
                    >状态:
                    {{
                      ["未处理", "已处理"][
                        orderData.schemeList[0].partsOrderStatus
                      ]
                    }}</span
                  >
                </div>
              </el-col>
              <el-col :span="6">
                <div class="right flex-between">
                  <span></span>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="gotoPage('parts')"
                    >{{ $lange == "en" ? "View Detail" : "查看" }}</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          class="os-list"
          v-if="orderData.schemeList[0].expatriateOrderStatus !== 10"
        >
          <div class="os-title">
            <el-row :gutter="40">
              <el-col :span="18">
                <div class="left flex-between">
                  <div class="title-control flex-between" style="opacity: 0">
                    <i class="el-icon-arrow-up"></i>
                  </div>
                  <p class="title">
                    {{ $lange == "en" ? "Field Service" : "外派服务单" }}
                  </p>
                  <span v-if="$lange == 'en'"
                    >Status:
                    {{
                      [
                        "To be reserved",
                        "to be assigned",
                        "to be reviewed",
                        "approved",
                        "rejected",
                        "Report uploaded",
                      ][orderData.schemeList[0].expatriateOrderStatus]
                    }}</span
                  >
                  <span v-else
                    >状态:
                    {{
                      [
                        "待预约",
                        "待指派",
                        "待审核",
                        "审核通过",
                        "审核拒绝",
                        "已上传附件-报告",
                      ][orderData.schemeList[0].expatriateOrderStatus]
                    }}</span
                  >
                </div>
              </el-col>
              <el-col :span="6">
                <div class="right flex-between">
                  <span></span>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="gotoPage('expatriate')"
                    >{{ $lange == "en" ? "View Detail" : "查看" }}</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          class="os-list"
          v-if="orderData.schemeList[0].expatriateOrderStatus === 5"
        >
          <div class="os-title">
            <el-row :gutter="40">
              <el-col :span="18">
                <div class="left flex-between">
                  <div
                    class="title-control flex-between"
                    @click="showOrderVerify = !showOrderVerify"
                  >
                    <i class="el-icon-arrow-up" v-if="!showOrderVerify"></i>
                    <i class="el-icon-arrow-down" v-else></i>
                  </div>
                  <p class="title">
                    {{
                      $lange == "en"
                        ? "service fee calculation"
                        : "工单费用核实"
                    }}
                  </p>
                  <span v-if="$lange == 'en'"
                    >Status:
                    {{
                      ["Processing", "completed"][
                        orderData.schemeList[0].productFeeStatus
                      ]
                    }}</span
                  >
                  <span v-if="$lange != 'en'"
                    >状态:
                    {{
                      ["待处理", "已处理"][
                        orderData.schemeList[0].productFeeStatus
                      ]
                    }}</span
                  >
                </div>
              </el-col>
              <el-col :span="6">
                <div
                  class="right flex-between"
                  style="justify-content: flex-end"
                >
                  <template v-if="showOrderVerify">
                    <template v-if="isHandle">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="saveProductFee"
                        style="margin-right: 20px"
                        v-if="orderData.schemeList[0].productFeeStatus === 0"
                        >{{
                          $lange == "en" ? "Send to customer" : "发送给客户"
                        }}</el-button
                      >
                    </template>
                  </template>
                  <template v-else>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="showOrderVerify = true"
                      >{{ $lange == "en" ? "View Detail" : "查看" }}</el-button
                    >
                  </template>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-collapse-transition>
            <div class="os-content order-verify" v-show="showOrderVerify">
              <div class="os-con-list switch-btn flex-between">
                <p>
                  {{ $lange == "en" ? "Parts cost" : "配件费用(销售价)" }}:
                  {{ orderData.schemeList[0].productFee.partsFee }}元
                </p>
                <p style="margin-left: 160px">
                  {{
                    $lange == "en"
                      ? "Cost type of accessories"
                      : "配件费用类型"
                  }}:
                  {{
                    orderData.schemeList[0].productFee.partsFeeStatus == 0
                      ? "免费"
                      : "付费"
                  }}
                </p>
              </div>
              <!--                            v-if="orderData.schemeList[0].productFee.type === 2"-->
              <div class="os-con-list switch-btn flex-between">
                <p>
                  {{ $lange == "en" ? "Traffic expense" : "交通费" }}
                  <span style="display: inline-block" v-if="isHandle">
                    <el-input
                      size="mini"
                      v-model="orderData.schemeList[0].productFee.trafficFee"
                    ></el-input>
                  </span>
                  <span v-else>{{
                    orderData.schemeList[0].productFee.trafficFee
                  }}</span>
                  {{ $lange == "en" ? "" : "元" }}
                </p>
                <p>
                  {{ $lange == "en" ? "Hotel expense" : "餐宿费" }}
                  <span style="display: inline-block" v-if="isHandle">
                    <el-input
                      size="mini"
                      v-model="
                        orderData.schemeList[0].productFee.accommodationFee
                      "
                    ></el-input>
                  </span>
                  <span v-else>{{
                    orderData.schemeList[0].productFee.accommodationFee
                  }}</span>
                  {{ $lange == "en" ? "" : "元" }}
                </p>
                <p>
                  {{ $lange == "en" ? "Service charge" : "服务费" }}
                  <span style="display: inline-block" v-if="isHandle">
                    <el-input
                      size="mini"
                      v-model="orderData.schemeList[0].productFee.serviceFee"
                    ></el-input>
                  </span>
                  <span v-else>{{
                    orderData.schemeList[0].productFee.serviceFee
                  }}</span>
                  {{ $lange == "en" ? "" : "元" }}
                </p>
                <p>
                  {{
                    $lange == "en"
                      ? "Total （Does not include accessories costs）"
                      : "合计 (不包含配件费用)"
                  }}
                  <span>{{
                    orderData.schemeList[0].productFee.serviceFee * 1 +
                    orderData.schemeList[0].productFee.accommodationFee * 1 +
                    orderData.schemeList[0].productFee.trafficFee * 1
                  }}</span>
                  {{ $lange == "en" ? "" : "元" }}
                </p>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <div class="os-list" v-if="orderData.schemeList[0].evaluationId != 10">
          <div class="os-title">
            <el-row :gutter="40">
              <el-col :span="18">
                <div class="left flex-between">
                  <div
                    class="title-control flex-between"
                    @click="showEvaluation = !showEvaluation"
                  >
                    <i class="el-icon-arrow-up" v-if="!showEvaluation"></i>
                    <i class="el-icon-arrow-down" v-else></i>
                  </div>
                  <p class="title">
                    {{ $lange == "en" ? "Service Rating" : "客户评价" }}
                  </p>
                  <span v-if="orderData.schemeList[0].evaluationId == 0">
                    <template v-if="$lange == 'en'"
                      >Status:
                      {{
                        `Waiting for customer evaluation, exceeding ${orderData.schemeList[0].evaluationDay} days`
                      }}</template
                    >
                    <template v-else
                      >状态:
                      {{
                        `等待客户评价，超过${orderData.schemeList[0].evaluationDay}天`
                      }}</template
                    >
                  </span>
                  <span v-else>{{
                    $lange == "en" ? "Status: completed" : "状态: 已评价"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="right flex-between">
                  <template v-if="showEvaluation">
                    <template v-if="isHandle"></template>
                  </template>
                  <template v-else>
                    <span></span>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="showEvaluation = true"
                      >{{ $lange == "en" ? "View Details" : "查看" }}</el-button
                    >
                  </template>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-collapse-transition>
            <div class="os-content order-verify" v-show="showEvaluation">
              <template
                v-if="orderData.schemeList[0].workOrderEvaluation != null"
              >
                <div class="os-con-list switch-btn flex-between">
                  <p>
                    {{ $lange == "en" ? "Comment content" : "评论内容" }}:
                    {{ orderData.schemeList[0].workOrderEvaluation.content }}
                  </p>
                </div>
                <div class="os-con-list switch-btn flex-between">
                  <p>
                    {{ $lange == "en" ? "Score" : "评分" }}:
                    {{ orderData.schemeList[0].workOrderEvaluation.starRating }}
                  </p>
                </div>
              </template>
            </div>
          </el-collapse-transition>
        </div>
      </template>
    </div>
    <el-dialog
      :title="$lange == 'en' ? 'Add remark' : '添加备注'"
      :visible.sync="addRemark"
      width="30%"
      class="partsForm"
      append-to-body
    >
      <el-input
        size="mini"
        type="textarea"
        :rows="4"
        v-model="remarkMsg"
        :placeholder="$lange == 'en' ? 'Please enter remark' : '请输入备注'"
      ></el-input>
      <div
        class="flex-between"
        style="justify-content: flex-end; margin-top: 15px"
      >
        <el-button size="mini" @click="addRemark = false">{{
          $lange == "en" ? "Cancel" : "取消"
        }}</el-button>

        <el-button type="primary" size="mini" @click="saveRemark">{{
          $lange == "en" ? "Submit" : "添加"
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Spare Part List' : '添加配件'"
      :visible.sync="addPartsFlag"
      width="80%"
      class="partsForm"
      append-to-body
    >
      <div
        class="flex-between params-input"
        style="justify-content: flex-start; margin-bottom: 20px"
      >
        <el-input
          v-model="addPartsTableParams.fiCode"
          size="mini"
          :placeholder="
            $lange == 'en' ? 'Please enter FI Code' : '请输入 FI Code'
          "
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          v-model="addPartsTableParams.fasCode"
          size="mini"
          :placeholder="
            $lange == 'en' ? 'Please enter Fas Code' : '请输入 Fas Code'
          "
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          v-model="addPartsTableParams.partsName"
          size="mini"
          :placeholder="
            $lange == 'en' ? 'Please enter Keyword' : '请输入关键字'
          "
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>

      <cc-table
        :config="addPartsTableConfig"
        :params="addPartsTableParams"
      ></cc-table>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Selective inventory' : '选择库存'"
      :visible.sync="chooseParts"
      width="30%"
      append-to-body
    >
      <el-form ref="form" label-width="80px">
        <el-checkbox-group v-model="addPartsForm.type" prop="type">
          <template v-for="item in addPartsForm.form">
            <div style="margin-bottom: 15px">
              <el-checkbox :label="item.id" name="type">
                {{ item.name }}:
                <el-input
                  v-model.number="item.num"
                  :disabled="addPartsForm.type.indexOf(item.id) < 0"
                  size="mini"
                  placeholder="输入数量"
                  style="max-width: 160px"
                  type="number"
                ></el-input>
                <span
                  style="
                    display: inline-block;
                    margin-left: 5px;
                    font-size: 12px;
                  "
                  >{{ $lange == "en" ? "Inventory remaining" : "库存剩余" }}:{{
                    nowParts[item.id]
                  }}</span
                >
              </el-checkbox>
              <!--                            <p>-->
              <!--                                <el-alert-->
              <!--                                        type="info"-->
              <!--                                        :title="'该仓库当前剩余'+"-->
              <!--                                        :closable="false"-->
              <!--                                        show-icon-->
              <!--                                        style="padding: 3px 5px; margin-top: 5px"-->
              <!--                                ></el-alert>-->
              <!--                            </p>-->
            </div>
          </template>
        </el-checkbox-group>
        <el-form-item>
          <el-button type="primary" size="mini" @click="isAddParts">{{
            $lange == "en" ? "Submit" : "确定"
          }}</el-button>
          <el-button size="mini" @click="cancelAddParts">{{
            $lange == "en" ? "Cancel" : "取消"
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Upload attachments' : '上传附件'"
      :visible.sync="showUploadPartsFile"
      width="30%"
      append-to-body
    >
      <cc-uploader
        :config="uploaderConf2"
        :notFormat="['text/plain']"
        :useSuccess="true"
        @upload-success="partsFileSuccess"
      />
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Upload attachments' : '上传附件'"
      :visible.sync="showUploadInviteFile"
      width="30%"
      append-to-body
    >
      <cc-uploader
        :config="uploaderConf2"
        :useSuccess="true"
        @upload-success="inviteFileSuccess"
      />
    </el-dialog>
    <el-dialog :visible.sync="showImageFlag" width="80%" append-to-body>
      <img :src="nowShowImageUrl" style="display: block; margin: 0 auto" alt />
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Edit accessories' : '修改配件'"
      :visible.sync="showPartsEdits"
      @close="partsEditsClose"
      @open="partsEditsOpen"
      width="20%"
      append-to-body
    >
      <div
        class="edit-parts"
        v-if="editPartsItem && typeof editPartsItem === 'object'"
      >
        <div>
          <span>{{ $lange == "en" ? "Accessories name" : "配件名称" }}:</span>
          <span>{{ editPartsItem.parts.partsName }}</span>
        </div>
        <div class="flex-between">
          <span>{{ $lange == "en" ? "Number" : "数量" }}:</span>
          <el-input
            size="mini"
            style="max-width: 120px"
            v-model.number="editPartsItem.partsNum"
          ></el-input>
        </div>
        <div class="flex-between">
          <span>{{ $lange == "en" ? "Final offer" : "最终报价" }}:</span>
          <el-input
            size="mini"
            style="max-width: 120px"
            v-model.number="editPartsItem.relPrice"
          ></el-input>
        </div>
        <!--                <div class="flex-between">-->
        <!--                    <span>{{$lange=='en' ? 'Cost type' : '费用类型'}}:</span>-->
        <!--                    <el-radio-group v-model="editPartsItem.feeType">-->
        <!--                        <el-radio :label="0">{{$lange=='en' ? 'Free Admission' : '免费'}}</el-radio>-->
        <!--                        <el-radio :label="1">{{$lange=='en' ? 'Charge' : '收费'}}</el-radio>-->
        <!--                    </el-radio-group>-->
        <!--                </div>-->
      </div>
      <div class="flex-between">
        <el-button size="mini" type="primary" @click="savePartsEdit">{{
          $lange == "en" ? "Save" : "保存"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UserCard from "../../../components/UserCard";
import moment from "moment";
import axios from "axios";
export default {
  name: "OrderComponent",
  props: {
    isCreate: {
      type: Boolean,
      default: false,
    },
    isHandle: {
      type: Boolean,
      default: false,
    },
    fileData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    orderIdV2: String,
    isHandleV2: Boolean,
    isDialog: Boolean,
  },
  computed: {
    orderStatusFilter() {
      let obj = this.orderData;
      let res = this.orderStatus[obj.status].title;
      if (obj.status === 1 && obj.handleStatus === 1) {
        res = "配件准备中";
      }
      if (obj.status === 1 && obj.handleStatus === 2) {
        res = "现场服务安排中";
      }
      return res;
    },
  },
  data() {
    return {
      productStatus: ["新增", "安装", "保内", "保外"],
      productStatusEN: ["New", "Installation", "Warranty", "Out of Warranty"],
      //工单客户卡片
      cardConfig: {
        id: false,
        api: "admin/fsb/customer/save",
        customerName: "", // 公司的中文名称
        englishName: "", // 公司的英文名称
        isOrderEdit: false,
        isOrderCreate: false,
        isOrder: true,
        customerId: "",
        image: "", //图片
        formLists: [
          //表单内容
          {
            name: this.$lange == "en" ? "ID" : "客户ID",
            value: "",
            key: "customerNo",
          },
          {
            name: this.$lange == "en" ? "Credit Rating" : "信用等级",
            value: "",
            key: "creditLevel",
          },
          {
            name: this.$lange == "en" ? "Customer Satisfaction" : "年度满意度",
            value: "",
            key: "",
          },
          {
            name: this.$lange == "en" ? "Spare Part discount" : "配件折扣",
            value: "",
            key: "discount",
          },
          {
            name: this.$lange == "en" ? "Address" : "地址",
            value: "",
            key: "customerAddress",
          },
          {
            name: this.$lange == "en" ? "Customer Manager" : "客户经理",
            value: "",
            key: "customerManager",
          },
          {
            name: this.$lange == "en" ? "Create time" : "创建时间",
            type: "input",
            value: "",
            key: "createTime",
          },
        ],
      },
      nowShowImageUrl: "", //当前放大图片Url
      showImageFlag: false, //点击放大工单图片
      //机器选择的下拉
      machineSelectorConfig: {
        api: "admin/fsb/machine/query?jobId=null&pageSize=999&isAsc=true",
        isDisable: false,
        valProp: "id",
        labelProp: this.$lange == "en" ? "machineEnModel" : "machineModel",
        valueType: "String",
        width: "100%",
      },
      //jobId选择的下拉
      jobIdArr: [],
      principalSelector: [],
      contactSelector: [], //申请人选择的下拉
      orderTypeOptions: ["安装服务", "售后服务"], //工单类型
      orderStatus: [
        { title: "全部" },
        { title: "申请中" },
        { title: "处理中" },
        { title: "客户处理中" },
        { title: "已完成" },
        { title: "已评价" },
        { title: "已关闭" },
      ], //工单状态
      orderId: "", //当前工单id

      showHandleData: true, //控制工单处理方案的展示
      addRemark: false, //工程师备注弹窗
      remarkMsg: "", //备注输入的信息绑定
      remarkArr: [], //当前工单的备注信息
      engineerId: "", //工单转移的工程师id
      engineerName: "", //工单转移的工程师name
      //工单处理方案的表单
      handleData: {
        machineId: "",
        orderType: "",
        malfunction: null,
        problem: null,
        problemId: "",
        malfunctionId: "",
        remarkArr: [],
        replyContent: "",
        isExpatriate: false,
        isParts: false,
        notConfirm: false, //是否不需要客户确认方案，直接通过
        sendProblemParts: false,
      },
      //故障分类的下拉
      malfunctionSelectorConfig: {
        valueType: "String",
        api:
          "admin/fsb/work/order/attribute/query?code=0&pageSize=999&isAsc=true&type=" +
          (this.$lange == "en" ? "1" : "0"),
        valProp: "id",
        labelProp: "name",
        width: "100%",
      },
      //问题选择的下拉
      problemSelectorConfig: {
        valueType: "String",
        api:
          "admin/fsb/work/order/attribute/query?code=1&pageSize=999&isAsc=true&type=" +
          (this.$lange == "en" ? "1" : "0"),
        valProp: "id",
        labelProp: "name",
        width: "100%",
      },
      //转移工程师 的下拉
      engineerSelectorConfig: {
        api: "admin/fsb/work/order/queryRoleSameUserList?roleTips=engineer&pageSize=999&isAsc=true",
        valProp: "id",
        labelProp: "name",
        width: "100%",
      },
      engineerSelectorList: [],
      showPartsEdits: false, //控制修改配件弹窗
      editPartsIndex: false, //当前修改配件的索引
      editPartsItem: {
        relPrice: "",
        parts: { partsName: "" },
        partsNum: "",
        feeType: "",
      }, //当前修改配件的对象
      showUploadPartsFile: false, //配件订单的附件上传
      totalFee: "0", //配件订单价格的总计
      partsTableLoad: false,
      partsTableConfig: {
        // showPager: true,
        columns: [
          {
            prop: "parts.fiCode",
            lable: "FI Code",
          },
          {
            prop: "parts.fasCode",
            lable: "FAS Code",
          },
          {
            prop: "parts.partsName",
            lable: this.$lange == "en" ? "Description" : "商品名称",
          },
          {
            prop: "parts.imageUrl",
            lable: this.$lange == "en" ? "Image" : "缩略图",
            type: "img",
            urlPropName: "parts.imageUrl",
            w: 30,
            h: 30,
            info: "建议图片尺寸79*79",
            sourceUrlPropName: "parts.imageUrl",
            imgCompressParams: "?x-oss-process=image/resize,w_50",
          },
          {
            prop: "partsNum",
            lable: this.$lange == "en" ? "Quantity" : "数量",
          },
          {
            prop: "parts.salePrice",
            lable: this.$lange == "en" ? "List Price" : "价格",
            render: (row) => {
              // return Math.ceil(row.parts.salePrice/100);
              return (row.parts.salePrice / 100).toFixed(2);
            },
          },
          {
            prop: "discount",
            lable: this.$lange == "en" ? "Spare Part Discount" : "折扣",
            render: (row) => {
              return row.discount / 10;
            },
          },
          {
            lable: this.$lange == "en" ? "Offered Price" : "最终报价",
            render: (row, index) => {
              return (row.relPrice / 100).toFixed(1);
            },
          },
          {
            lable: this.$lange == "en" ? "Delivery From" : "配件地址",
            render: (row) => {
              let res = "---";
              if (this.$lange === "en") {
                switch (row.wareAddress) {
                  case "tjWarehouse":
                    res = "Tianjin";
                    break;
                  case "fsWarehouse":
                    res = "Foshan";
                    break;
                  case "shWarehouse":
                    res = "Shanghai";
                    break;
                  case "consignmentSale":
                    res = "Consignment";
                    break;
                }
              } else {
                switch (row.wareAddress) {
                  case "tjWarehouse":
                    res = "天津";
                    break;
                  case "fsWarehouse":
                    res = "佛山";
                    break;
                  case "shWarehouse":
                    res = "上海";
                    break;
                  case "consignmentSale":
                    res = "寄售";
                    break;
                  case "cdWarehouse":
                    res = "成都";
                    break;
                }
              }

              return res;
            },
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Status" : "状态",
            render: (row) => {
              return ["备料中", "部分发货", "已发货"][row.status];
            },
          },
          // {
          //     prop: "feeType",
          //     lable: this.$lange == 'en' ?  'Cost type' : '费用类型',
          //     render: row => {
          //         return ["免费", "收费"][row.feeType];
          //     }
          // },
        ],
        buttonsLabel: this.$lange == "en" ? "Edit" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Delete" : "移除",
            check: (row) => {
              return (
                this.isHandle && this.orderData.schemeList[0].isConfirm !== 1
              );
            },
            click: (row, $index) => {
              this.$confirm("此操作会移除该配件", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.orderData.schemeList[0].workOrderLogList[0].partsOrder.partsOrderLogList.splice(
                    $index,
                    1
                  );
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.totalFeeFun();
                })
                .catch(() => {});
            },
          },
          {
            name: this.$lange == "en" ? "Edit" : "修改",
            check: (row) => {
              return (
                this.isHandle && this.orderData.schemeList[0].isConfirm !== 1
              );
            },
            click: (row, $index) => {
              this.showPartsEdits = true;
              this.editPartsIndex = $index;
              this.editPartsItem = JSON.stringify(row);
            },
          },
        ],
      }, //配件的表格
      chooseParts: false, //悬着配件库存及数量的弹窗
      addPartsFlag: false, //控制添加配件表单的弹窗
      nowParts: false, //当前选择添加的配件
      addPartsTableParams: {
        fiCode: "",
        fasCode: "",
        partsName: "",
      }, //所有配件的筛选
      addPartsTableConfig: {
        api: "admin/fsb/parts/query",
        showPager: true,
        pageSize: 10,
        columns: [
          {
            prop: "fasCode",
            lable: "FAS Code",
            type: "input",
          },
          {
            prop: "fiCode",
            lable: "FI Code",
            type: "input",
          },
          {
            prop: "imageUrl",
            lable: this.$lange == "en" ? "Image" : "图片",
            type: "img",
            urlPropName: "imageUrl",
            editAble: true,
            required: true,
            w: 30,
            h: 30,
            info: "建议图片尺寸79*79",
            sourceUrlPropName: "imageUrl",
            imgCompressParams: "?x-oss-process=image/resize,w_50",
          },
          {
            prop: "partsName",
            lable: this.$lange == "en" ? "Accessories name" : "配件名称",
            type: "input",
          },
          {
            prop: "partsDescription",
            lable: this.$lange == "en" ? "Equipment" : "适用设备",
            type: "input",
          },
          {
            prop: "warehouseNum",
            lable: this.$lange == "en" ? "Total inventory" : "库存总数",
            type: "input",
          },
          {
            prop: "fsWarehouse",
            lable: this.$lange == "en" ? "Foshan" : "佛山",
            type: "input",
          },
          {
            prop: "shWarehouse",
            lable: this.$lange == "en" ? "Shanghai" : "上海",
          },
          {
            prop: "tjWarehouse",
            lable: this.$lange == "en" ? "Tianjin" : "天津",
          },
          {
            prop: "cdWarehouse",
            lable: this.$lange == "en" ? "Chengdu" : "成都",
          },
             {
            prop: "consignmentSale",
            lable: this.$lange == "en" ? "Consignment" : "寄售",
          },
          {
            prop: "salePrice",
            lable: this.$lange == "en" ? "Sale Price" : "价格",
            render: (row) => {
              return (row.salePrice / 100).toFixed(2);
              //   return Math.ceil(row.salePrice / 100).toFixed(1);
            },
          },
          {
            prop: "price",
            lable: this.$lange == "en" ? "Cost" : "成本",
            render: (row) => {
              //   return Math.ceil(row.price / 100);
              return (row.price / 100).toFixed(2);
            },
          },
          {
            prop: "contactName",
            lable: this.$lange == "en" ? "Cumulative shipment" : "累计出货",
          },
          {
            prop: "updateTime",
            lable: this.$lange == "en" ? "Update time" : "更新时间",
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Remark" : "备注",
            type: "input",
            editAble: true,
            required: true,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Add" : "添加",
            click: (row) => {
              this.nowParts = row;
              this.chooseParts = true;
            },
          },
        ],
      }, //所有配件的列表
      addPartsForm: {
        form: [
          {
            name: this.$lange == "en" ? "Foshan" : "佛山",
            id: "fsWarehouse",
            num: 1,
          },
          {
            name: this.$lange == "en" ? "Shanghai" : "上海",
            id: "shWarehouse",
            num: 1,
          },
          {
            name: this.$lange == "en" ? "Tianjin" : "天津",
            id: "tjWarehouse",
            num: 1,
          },
            {
            name: this.$lange == "en" ? "Tianjin" : "成都",
            id: "cdWarehouse",
            num: 1,
          },
          {
            name: this.$lange == "en" ? "Consignment" : "寄售",
            id: "consignmentSale",
            num: 1,
          },
        ],
        type: [],
      }, //添加配件的表单信息
      //配件专员 的下拉
      handlerSelectorConfig: {
        api: "admin/fsb/work/order/queryUserList?roleTips=accessoriesSpecialist&pageSize=999&isAsc=true",
        clearable: false,
        valProp: "id",
        labelProp: "name",
        width: "100%",
      },

      showUploadInviteFile: false, //外派邀请函弹窗
      inviteFile: [{ fileName: "---" }], //外派邀请函
      historyData: [], //历史沟通记录
      historyShow: false, //历史沟通记录收缩
      finishType: [
        "未处理",
        "处理完成",
        "处理完成，已确认报价",
        "处理完成，待确认报价",
      ], //处理方案状态
      finishTypeV2: [
        "Untreated",
        "Complete",
        "Complete，Confirmed",
        "Complete，Unconfirmed",
      ], //处理方案状态

      //当前的工单信息
      orderData: {
        jobId: "",
        phone: "",
        title: "",
        description: "",
        machine: {
          machineName: "",
          machineAbbr: "",
          fiCom: "",
        },
        customer: {
          id: "",
        },
      },
      lastOrder: {}, //备份获取的工单信息，当改动后点击取消，复原一切修改
      //工单 创建/修改 上传的表单信息
      postForm: {
        title: "",
        description: "",
        customerId: "",
        machineId: "",
        userId: "",
        userName: "",
        phone: "",
        accessoryInfoList: [],
      },
      userData: {},
      showOrderVerify: false,
      showEvaluation: false,

      uploaderConf2: this.$uploadUtils.config, //文件上传需要
    };
  },
  methods: {
    getTabText() {
      this.ccRequest
        .do("admin/dict/pageTree", { code: "productStatus" }, "GET")
        .then((res) => {
          let productStatus = [];
          let productStatusEN = [];
          if (res.rows && res.rows.length > 0) {
            for (let index = 0; index < res.rows[0].children.length; index++) {
              if (this.$lange == "zh") {
                productStatus.push(res.rows[0].children[index].title);
              } else {
                if (
                  res.rows[0].children[index].extraData &&
                  res.rows[0].children[index].extraData[this.$lange]
                ) {
                  productStatusEN.push(
                    res.rows[0].children[index].extraData[this.$lange]
                  );
                } else {
                  productStatus.push(res.rows[0].children[index].title);
                }
              }
            }
          }
        });
      this.productStatus = productStatus;
      this.productStatusEN = productStatusEN;
    },
    temporaryStorage() {
      // /admin/fsb/scheme/save 传参：id(方案id)，temporaryContent(富文本内容)  POST请求 Body形式
      let pData = {
        id: this.orderData.schemeId,
        temporaryContent: this.handleData.replyContent,
      };
      this.ccRequest
        .do("admin/fsb/scheme/save", pData, "POSTJSON")
        .then((res) => {
          this.$message({
            type: "success",
            message: "暂存成功",
          });
        });
    },
    deleteImage(idx) {
      this.postForm.accessoryInfoList.splice(idx, 1);
    },
    //编辑的时候获取一下jobId
    editOrder() {
      this.cardConfig.isOrderEdit = true;
      this.getJobId();
      this.machineSelectorConfig.api = `admin/fsb/machine/query?jobId=${this.orderData.jobId}&pageSize=999&isAsc=true`;
    },
    downloadFile(data, name) {
      if (data.accessoryUrl.length < 1) {
        return this.$message({
          type: "warning",
          message: "请联系管理员上传",
        });
      }
      if (data.fileName.indexOf("pdf") > -1) {
        let pData = {
          url: data.accessoryUrl,
        };
        return this.ccRequest
          .do("admin/fsb/file/aliyun/privateDownloadUrl", pData, "GET")
          .then((res) => {
            axios({
              method: "get",
              url: res.url,
              headers: {
                "Content-Disposition": "attachment",
              },
            }).then((res2) => {
              this.$message({
                type: "success",
                message: "文件已下载",
              });
            });
          });
      }

      this.$message({
        type: "success",
        message: "文件已下载",
      });
      let imageType = ["png", "jpg", "jpeg", "webp"];
      for (let i in imageType) {
        if (data.fileName.indexOf(imageType[i]) > -1) {
          this.downloadImage(data.accessoryUrl, name);
          return false;
        }
      }
      let a = document.createElement("a");
      a.href = data.accessoryUrl;
      a.download = name;
      a.click();
    },
    downloadImage(imgsrc, name) {
      // 下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    // 原先是 工单费用核实  卡片里的保存, 后面跟发送给客户合并到同一个接口
    saveProductFee() {
      this.$confirm("你当前的操作会给客户推送通知", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = this.orderData;
        let pData = {
          id: data.schemeList[0].productFee.id,
          trafficFee: data.schemeList[0].productFee.trafficFee * 100,
          accommodationFee:
            data.schemeList[0].productFee.accommodationFee * 100,
          serviceFee: data.schemeList[0].productFee.serviceFee * 100,
          workOrderSchemeId: data.schemeList[0].id,
        };
        this.ccRequest
          .do("admin/fsb/product/fee/save", pData, "POSTJSON")
          .then((res) => {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            setTimeout(() => {
              this.$router.push({
                name: "OrderList",
              });
            }, 1000);
          });
      });
    },
    sendCustomer() {
      this.$confirm("你当前的操作会给客户推送通知", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = this.orderData;
        let pData = {
          workOrderSchemeId: data.schemeList[0].id,
        };
        this.ccRequest
          .do("admin/fsb/scheme/sendCustomer", pData, "GET")
          .then((res) => {
            this.$message({
              type: "success",
              message: "发送成功",
            });
            this.getOrderData();
          });
      });
    },
    gotoPage(type = false) {
      let path = "";
      let params = {
        id: "",
      };
      if (type == "parts") {
        path = "/admin/order/list/parts/des";
        params.id = this.orderData.schemeList[0].partsOrderId;
      }
      if (type == "expatriate") {
        path = "/admin/order/expatriate/des";
        params.id = this.orderData.schemeList[0].expatriateOrderId;
      }
      console.log(params);
      this.$router.push({
        path: path,
        query: params,
      });
    },
    // cancelItem(value){
    // 无调用 暂时隐藏
    //        value === this.orderData.schemeList[0].workOrderLogList[0].partsOrder.payment ?
    //             this.orderData.schemeList[0].workOrderLogList[0].partsOrder.payment = '' :
    //             this.orderData.schemeList[0].workOrderLogList[0].partsOrder.payment = value;
    //
    // },
    //获取邀请函附件
    getInviteFile() {
      let data = {
        objType: "serviceInvitation",
      };
      this.ccRequest
        .do("admin/fsb/accessory/query", data, "GET")
        .then((res) => {
          this.inviteFile = res.rows;
        });
    },
    //外派邀请函附件上传成功
    inviteFileSuccess(res) {
      console.log(res);
      this.showUploadInviteFile = false;

      this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder.serviceInvitation =
        {
          fileName: res.fileName,
          accessoryUrl: res.accessoryUrl,
        };

      // 2019-12-13  老的邀请函是一次上传全部通用, 后面客户说要改成每条工单对应一个邀请函
      // let data = {
      //     objType: "serviceInvitation",
      //     fileName: res.fileName,
      //     accessoryUrl: res.accessoryUrl,
      // }
      // this.ccRequest.do("admin/fsb/accessory/save", data, "POSTJSON").then(res => {
      //     this.inviteFile = [{fileName: res.fileName, accessoryUrl: res.accessoryUrl}]
      //     this.$message({
      //         type: "success",
      //         message: "上传附件成功"
      //     })
      // })
    },

    //获取申请人
    getContact() {
      let data = {
        workOrderId: this.orderId,
        customerId: this.orderData.customer.id,
        jobId: this.orderData.jobId,
        pageSize: 999,
        isAsc: true,
      };
      // this.orderData.userId = "";
      this.ccRequest
        .do("admin/fsb/work/order/queryApplicant", data, "GET")
        .then((res) => {
          this.contactSelector = res;
        });
    },
    //获取负责人
    getPrincipal() {
      let data = {
        // roleTips: "projectmanager"
        roleTips: "technicalSupport",
      };
      this.ccRequest
        .do("admin/fsb/work/order/queryUserList", data, "GET")
        .then((res) => {
          this.principalSelector = res.rows;
        });
    },
    //获取jobId
    getJobId() {
      let data = {
        pageSize: 999,
        customerId: this.orderData.customer.id,
      };
      this.ccRequest.do("admin/fsb/product/query", data, "GET").then((res) => {
        this.jobIdArr = res.rows;
      });
    },

    //点击 “核实收付款” 的查看跳转到 “付款附件” tab
    changeActiveName() {
      this.$emit("changeActiveName", "file");
    },
    //展示大图
    showImage(url) {
      this.nowShowImageUrl = url;
      this.showImageFlag = true;
    },
    // 提交解决方案
    saveWorkOrder() {
      let confirmTitle = "你的当前操作提交解决方案";
      // if(this.userData.roleTips == 'technicalSupport'){
      //     confirmTitle = "你的当前操作提交解决方案";
      // }
      if (this.userData.roleTips == "accessoriesSpecialist") {
        confirmTitle = "你的当前操作确认报价 (此操作会推送给客户)";
      }
      this.$confirm(confirmTitle, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          replyContent: this.handleData.replyContent,
          workOrderId: this.orderData.id,
          handleType: 0,
          // workOrderLogId: this.orderData.schemeList[0].workOrderLogList[0].id
          // expatriateOrder: {},
          // partsOrderAddPo: {},
        };

        //判断是否有开启外派
        if (this.handleData.isExpatriate) {
          if (
            this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder
              .handlerId == ""
          ) {
            this.$message({
              type: "warning",
              message: "开启了外派服务, 负责人不能为空",
            });
            return false;
          }
          if (this.orderData.handlerId == "") {
            this.$message({
              type: "warning",
              message: "开启了外派服务, 审核人员不能为空",
            });
            return false;
          } else {
            data.handlerId = this.orderData.handlerId;
          }
          // let feeType = this.orderData.product.status === 3 ? 0 : 1;  //原来的判断
          let feeType = this.orderData.isUnderWarranty;
          data.expatriateOrder = {
            workHour:
              this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder
                .workHour,
            peopleNum:
              this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder
                .peopleNum,
            feeType: feeType,
            // handlerId: this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder.handlerId, //一开始是下拉框, 后来客户希望改成自动是当前登录的技术支持工程师
          };

          if (
            this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder
              .serviceInvitation &&
            this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder
              .serviceInvitation.accessoryUrl.length > 1
          ) {
            data.expatriateOrder.serviceInvitation =
              this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder.serviceInvitation;
          }
          // console.log(data.expatriateOrder.serviceInvitation, "this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder.serviceInvitation");
          if (
            !this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder
              .handlerId
          ) {
            data.expatriateOrder.handlerId = this.userData.id;
          }
          if (
            data.expatriateOrder.workHour < 0.01 ||
            data.expatriateOrder.peopleNum < 1
          ) {
            return this.$message({
              type: "warning",
              message: "开启了外派服务单, 请输入正确的人数跟工时。",
            });
          }

          if (
            this.orderData.schemeList[0].workOrderLogList[0].handleType == 2 ||
            this.orderData.schemeList[0].workOrderLogList[0].handleType == 3
          ) {
            data.expatriateOrder.id =
              this.orderData.schemeList[0].workOrderLogList[0].expatriateOrder.id;
          }
        }

        // console.log(this.orderData.schemeList[0].workOrderLogList[0].partsOrder.partsOrderLogList, "this.orderData.schemeList[0].workOrderLogList[0].partsOrder.partsOrderLogList")
        //判断是否有开启配件订单
        if (this.handleData.isParts) {
          if (this.orderData.handlerId == "") {
            this.$message({
              type: "warning",
              message: "开启配件订单, 审核人员不能为空",
            });
            return false;
          } else {
            data.handlerId = this.orderData.handlerId;
          }
          if (
            this.orderData.schemeList[0].workOrderLogList[0].partsOrder
              .partsOrderLogList.length < 1
          ) {
            this.$message({
              type: "warning",
              message: "开启配件订单, 请添加配件",
            });
            return false;
          }
          if (
            this.totalFee > 0 &&
            this.orderData.schemeList[0].workOrderLogList[0].partsOrder
              .payment === undefined
          ) {
            this.$message({
              type: "warning",
              message: "配件订单中有需要收费的配件, 请选择支付方式",
            });
            return false;
          }
          let partsOrderData = [];
          for (let i in this.orderData.schemeList[0].workOrderLogList[0]
            .partsOrder.partsOrderLogList) {
            let item =
              this.orderData.schemeList[0].workOrderLogList[0].partsOrder
                .partsOrderLogList[i];
            // item.feeType = this.orderData.isUnderWarranty

            partsOrderData.push({
              discount: item.discount,
              partsId: item.partsId,
              feeType: this.orderData.isUnderWarranty,
              partsNum: item.partsNum,
              wareAddress: item.wareAddress,
              relPrice: item.relPrice,
              jobId: this.orderData.jobId,
            });
          }
          data.partsOrderAddPo = {
            payment:
              this.orderData.schemeList[0].workOrderLogList[0].partsOrder
                .payment,
            sendProblemParts: this.handleData.sendProblemParts ? 1 : 0,
            accessoryInfoList:
              this.orderData.schemeList[0].workOrderLogList[0].partsOrder
                .accessoryInfoList,
            partsOrderLogPolist: partsOrderData,
          };
          if (
            this.orderData.schemeList[0].workOrderLogList[0].handleType == 1 ||
            this.orderData.schemeList[0].workOrderLogList[0].handleType == 3
          ) {
            data.partsOrderAddPo.id =
              this.orderData.schemeList[0].workOrderLogList[0].partsOrder.id;
          }
        }
        this.handleData.isParts && (data.handleType = 1);
        this.handleData.isExpatriate && (data.handleType = 2);
        if (this.handleData.isParts && this.handleData.isExpatriate) {
          data.handleType = 3;
        }
        if (
          (this.handleData.isParts || this.handleData.isExpatriate) &&
          this.totalFee < 0.01 &&
          this.orderData.isUnderWarranty === 0 &&
          this.handleData.notConfirm
        ) {
          data.notConfirm = 1;
        }

        this.ccRequest
          .do("admin/fsb/work/order/log/save", data, "POSTJSON")
          .then((res) => {
            this.$message({
              type: "success",
              message: "提交成功",
            });
            this.isHandle = false;
            // this.machineSelectorConfig.isDisable = true;
            // this.malfunctionSelectorConfig.isDisable = true;
            // this.problemSelectorConfig.isDisable = true;
            this.$router.push({
              name: "OrderList",
            });
          });
      });
    },
    //保存配件的编辑
    savePartsEdit() {
      let data = this.editPartsItem;
      data.relPrice = this.editPartsItem.relPrice * 100;
      console.log(data, "data -----------");
      console.log(
        this.editPartsIndex,
        this.orderData.schemeList[0].workOrderLogList[0].partsOrder
          .partsOrderLogList[this.editPartsIndex],
        "this.editPartsIndex"
      );
      this.orderData.schemeList[0].workOrderLogList[0].partsOrder.partsOrderLogList[
        this.editPartsIndex
      ] = data;
      this.showPartsEdits = false;
      this.totalFeeFun();
      this.$message({
        type: "success",
        message: "修改成功",
      });
    },
    //配件弹窗开启 —— 价格除以100   在表格的修改那里写会联动到表格里的数据 尝试过N种方法,最终选择这种
    partsEditsOpen() {
      this.editPartsItem = JSON.parse(this.editPartsItem);
      this.editPartsItem.relPrice = (this.editPartsItem.relPrice / 100).toFixed(
        1
      );
    },
    //配件弹窗关闭 —— 更新合计
    partsEditsClose() {
      this.partsTableLoad = true;
      setTimeout(() => {
        this.partsTableLoad = false;
      }, 100);
      this.editPartsIndex = false;
      this.editPartsItem = false;
      this.totalFeeFun();
    },
    // 配件附件上传成功获取文件名跟后缀
    partsFileSuccess(res) {
      console.log(res);
      this.showUploadPartsFile = false;
      this.orderData.schemeList[0].workOrderLogList[0].partsOrder.accessoryInfoList =
        [{ fileName: res.fileName, accessoryUrl: res.accessoryUrl }];
      this.$message({
        type: "success",
        message: "上传附件成功",
      });
    },
    //计算配件价格合计
    totalFeeFun() {
      let res = 0;
      for (let i in this.orderData.schemeList[0].workOrderLogList[0].partsOrder
        .partsOrderLogList) {
        let item =
          this.orderData.schemeList[0].workOrderLogList[0].partsOrder
            .partsOrderLogList[i];
        // 2019-12-13 客户去掉了配件中的免费与收费, 统一使用解决方案中的免费与收费
        // if(item.feeType != 0){
        //     res += item.relPrice;
        // }
        if (this.orderData.isUnderWarranty === 1) {
          res += item.relPrice;
        }
      }

      this.totalFee = (res / 100).toFixed(1);
    },
    //取消添加配件 初始化表单内容
    cancelAddParts() {
      this.addPartsForm = {
        form: [
          {
            name: "佛山",
            id: "fsWarehouse",
            num: 1,
          },
          {
            name: "上海",
            id: "shWarehouse",
            num: 1,
          },
          {
            name: "天津",
            id: "tjWarehouse",
            num: 1,
          },
             {
            name: "成都",
            id: "cdWarehouse",
            num: 1,
          },
          {
            name: "寄售",
            id: "consignmentSale",
            num: 1,
          },

        ],
        type: [],
      };
      this.chooseParts = false;
    },
    //添加配件
    isAddParts() {
      let newData = [];
      let data = this.nowParts;
      console.log(data);
      for (let i in this.addPartsForm.form) {
        console.log(
          this.addPartsForm.form[i],
          this.addPartsForm.form[i].num,
          "this.addPartsForm.form[i].isActivethis.addPartsForm.form[i].isActivethis.addPartsForm.form[i].isActive"
        );

        if (this.addPartsForm.type.indexOf(this.addPartsForm.form[i].id) > -1) {
          if (this.addPartsForm.form[i].num < 1) {
            return this.$message({
              type: "warning",
              message: `${this.addPartsForm.form[i].name}仓库请输入正确的数值`,
            });
          }
          // console.log(data[this.addPartsForm.form[i].id], "1111112312")
          // if (
          //   this.addPartsForm.form[i].num > data[this.addPartsForm.form[i].id]
          // ) {
          //   return this.$message({
          //     type: "warning",
          //     message: `当前${this.addPartsForm.form[i].name}库存数量只有${
          //       data[this.addPartsForm.form[i].id]
          //     }, 请勿超出`
          //   });
          // }
          let totalFee = Math.ceil(
            data.salePrice * this.addPartsForm.form[i].num
          );
          if (
            this.orderData.customer.discount &&
            this.orderData.customer.discount > 0
          ) {
            totalFee = Math.ceil(
              totalFee * (this.orderData.customer.discount / 10)
            );
          }
          // console.log(this.orderData.customer.discount, "data.price * this.addPartsForm.form[i].num")
          newData.push({
            partsId: data.id,
            parts: {
              fiCode: data.fiCode,
              fasCode: data.fasCode,
              partsName: data.partsName,
              imageUrl: data.imageUrl,
              salePrice: data.salePrice,
              // salePrice: "",
            },
            partsNum: this.addPartsForm.form[i].num,
            discount: this.orderData.customer.discount,
            relTotal: 0,
            wareAddress: this.addPartsForm.form[i].id,
            // status: this.orderData.product.status == 2 ? 0 : 1,
            status: 0,
            relPrice: totalFee,
            feeType: this.orderData.isUnderWarranty,
          });
        }
      }

      this.orderData.schemeList[0].workOrderLogList[0].partsOrder.partsOrderLogList.push(
        ...newData
      );
      this.totalFeeFun();
      this.cancelAddParts();
      this.$message({
        type: "success",
        message: "添加成功",
      });
    },

    //工单转移切换工程师
    engineerChange(res) {
      // this.engineerId = res;
      let newData = this.engineerSelectorList.find((item) => {
        return item.id === res;
      });
      this.engineerName = newData.name;
    },
    //确认转移
    turnEngineer() {
      if (this.engineerId.length < 1) {
        this.$message({
          type: "warning",
          message: "工程师为空,不可转移",
        });
        return false;
      }
      this.$confirm(`是否确认把工单转移给 ${this.engineerName}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      }).then(() => {
        let data = {
          id: this.orderData.id,
          handlerId: this.engineerId,
        };
        this.ccRequest
          .do("admin/fsb/work/order/transfer", data, "POSTJSON")
          .then((res) => {
            console.log(res);
            this.$router.push({
              name: "OrderList",
            });
            this.$message({
              type: "success",
              message: "转移成功",
            });
          });
      });
    },
    //添加备注
    saveRemark() {
      let data = {
        remark: this.remarkMsg,
        id: this.orderData.id,
      };
      this.ccRequest
        .do("admin/fsb/work/order/save", data, "POSTJSON")
        .then((res) => {
          this.orderData.extraData = res.extraData;
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.remarkMsg = "";
          this.addRemark = false;
        });
    },
    //工单类型修改
    workTypeChange(res) {
      if (!res) {
        return false;
      }
      let data = {
        requestType: res,
        id: this.orderData.id,
      };
      this.ccRequest
        .do("admin/fsb/work/order/save", data, "POSTJSON")
        .then((res) => {});
    },
    //优先级修改
    priorityChange(res) {
      if (!res) {
        return false;
      }
      let data = {
        priority: res,
        id: this.orderData.id,
      };
      this.ccRequest
        .do("admin/fsb/work/order/save", data, "POSTJSON")
        .then((res) => {});
    },
    //保内保外转换
    isUnderWarrantyChange(res) {
      let data = {
        isUnderWarranty: res,
        id: this.orderData.id,
      };
      this.ccRequest
        .do("admin/fsb/work/order/save", data, "POSTJSON")
        .then((res) => {
          this.totalFeeFun();
        });
    },
    // 问题来源选项
    problemChange(res) {
      console.log(res);
      this.handleData.problemId = res;
      let data = {
        problemId: res,
        id: this.orderData.id,
      };
      this.ccRequest
        .do("admin/fsb/work/order/save", data, "POSTJSON")
        .then((res) => {});
    },
    // 故障分类选择
    malfunctionChange(res) {
      console.log(res);
      this.handleData.malfunctionId = res;
      let data = {
        malfunctionId: res,
        id: this.orderData.id,
      };
      this.ccRequest
        .do("admin/fsb/work/order/save", data, "POSTJSON")
        .then((res) => {});
    },
    // 工单处理方案的机器关联
    machineChange2(res) {
      this.handleData.machineId = res;
      this.orderData.machine.id = res;
      let data = {
        machineId: res,
        id: this.orderData.id,
      };
      this.ccRequest
        .do("admin/fsb/work/order/save", data, "POSTJSON")
        .then((res) => {});
    },

    // 取消编辑
    cancelEdit() {
      if (this.$router.history.current.name == "OrderCreate") {
        this.$router.push({
          name: "OrderList",
        });
        return false;
      }
      if (this.isCreate) {
        this.$router.go(-1);
        return false;
      }
      let lastOrder = JSON.parse(this.lastOrder);
      this.orderData = {
        ...lastOrder,
      };
      this.cardConfig.isOrderEdit = false;
      this.postForm = {
        title: "",
        description: "",
        customerId: "",
        machineId: "",
        userId: "",
        userName: "",
        phone: "",
        accessoryInfoList: [],
      };
    },
    // 修改工单保存
    orderSave() {
      let data = this.postForm;
      if (!this.isCreate) {
        data.id = this.orderData.id;
        data.customerId = this.orderData.customerId;
      }
      data.userName = this.orderData.userName;
      data.title = this.orderData.title;
      data.description = this.orderData.description;
      data.phone = this.orderData.phone;
      data.userId = this.orderData.userId;

      console.log(data);
      // data.principalId = this.orderData.principalId; //移到解决方案的外派服务单了 暂时隐藏
      if (!data.customerId) {
        this.$message({
          type: "error",
          message: "请选择客户",
        });
        return false;
      }
      if (data.userName == "") {
        this.$message({
          type: "error",
          message: "申请人不能为空",
        });
        return false;
      }
      if (data.machineId == "") {
        this.$message({
          type: "error",
          message: "机器不能为空",
        });
        return false;
      }
      if (data.title == "") {
        this.$message({
          type: "error",
          message: "问题标题不能为空",
        });
        return false;
      }
      if (data.description == "") {
        this.$message({
          type: "error",
          message: "问题描述不能为空",
        });
        return false;
      }
      if (data.jobId.length < 1) {
        this.$message({
          type: "error",
          message: "jobId不能为空",
        });
        return false;
      }
      this.ccRequest
        .do("admin/fsb/work/order/save", data, "POSTJSON")
        .then((res) => {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.$router.push({
            path: "/admin/order/des",
            query: {
              id: res.id,
              showClose: 1,
            },
          });
          this.cardConfig.isOrderEdit = false;
        })
        .catch((res) => {
          this.cardConfig.isOrderEdit = true;
          this.$message({
            type: "warning",
            message: res.response.data.message,
          });
        });
    },
    // 机器选择
    machineChange(res) {
      this.postForm.machineId = res;
      let data = {
        id: res,
      };
      this.ccRequest.do("admin/fsb/machine/get", data, "GET").then((res2) => {
        this.orderData.machine.machineModel = res2.machineModel;
        this.orderData.machine.machineAbbr = res2.machineAbbr;
        this.orderData.machine.fiCom = res2.fiCom;
      });
    },
    //申请人选择 --- 获取手机号码
    contactChange(res) {
      // console.log(res, this.contactSelector, "contactSelector")
      for (let i in this.contactSelector) {
        if (this.contactSelector[i].userId === res) {
          this.postForm.userId = res;
          this.orderData.userId = res;
          this.orderData.phone = this.contactSelector[i].phone;
          this.orderData.userName = this.contactSelector[i].userName;
        }
      }
      // console.log(res, event)
      // let data = {
      //     id: res,
      // }
      // this.ccRequest.do("admin/fsb/customer/contact/get", data, "GET").then(res2 => {

      // })

      // console.log(this.postForm.customerId,res)
    },
    // jobId选择
    jobIdChange(res) {
      console.log(this.orderData, res);
      // this.orderData.machine = {
      //   fiCom: "",
      //   id: "",
      //   machineAbbr: "",
      //   machineModel: "",
      //   machineName: "",
      // };
      this.orderData.jobId = res;
      this.postForm.jobId = res;
      if (res.length > 0) {
        this.postForm.machineId = "";
        this.orderData.machine.id = "";
        this.machineSelectorConfig.api = `admin/fsb/machine/query?jobId=${res}&pageSize=999&isAsc=true`;
        this.getContact();
      }
      // let data = {
      //     jobId: res
      // }
      // this.ccRequest.do("admin/fsb/product/query", data, "GET").then(res => {
      //     console.log(res);
      //
      //     let product = {
      //         product: res
      //     }
      //     let orderData = {
      //         ...this.orderData,
      //         ...product
      //     }
      //     this.orderData = orderData;
      // })
    },
    // 工单上传图片成功
    uploadTrue(res) {
      this.postForm.accessoryInfoList.push({
        accessoryUrl: res,
      });
    },

    //选择 客户后清除jobId， 避免出现重复
    clearJob(customer) {
      // this.customerData = customer;
      let postForm = {
        title: "",
        description: "",
        customerId: customer.id,
        machineId: "",
        jobId: "",
        userId: "",
        userName: "",
        phone: "",
        accessoryInfoList: [],
      };

      if (customer.productList != "") {
        this.orderData.jobId = customer.productList[0].jobId;
        this.orderData.userName = "";
        this.orderData.machine.machineModel = "";
        postForm.jobId = customer.productList[0].jobId;
        this.machineSelectorConfig.api = `admin/fsb/machine/query?jobId=${customer.productList[0].jobId}&pageSize=999&isAsc=true`;
      }
      this.postForm = postForm;
      this.orderData.customer.id = customer.id;
      this.getContact();
      this.getJobId();
    },
    //获取工单信息
    getOrderData() {
      let data = {
        id: this.orderId,
      };
      // console.log(this.isHandle, "isHandel")
      if (this.isHandle) {
        data.isHandle = true;
      }
      this.ccRequest
        .do("admin/fsb/work/order/get", data, "GET")
        .then((res) => {
          if (this.userData.roleTips !== "accessoriesSpecialist") {
            res.handlerId = ""; //由于第一次进入处理，处理人不是配件专员，这里清空数值是解决配件专员的下拉框出现id的BUG
          }
          this.getEngineerData(
            `admin/fsb/work/order/queryRoleSameUserList?type=${res.type}&roleTips=engineer&pageSize=999&isAsc=true`
          );
          this.machineSelectorConfig.api = `admin/fsb/machine/query?jobId=${res.jobId}&pageSize=999&isAsc=true`;
          if (res.principalId != "") {
            res.principalId *= 1; //兼容下拉框  显示出来的是id
          }
          this.postForm.machineId = res.machine.id;
          if (res.schemeList[0].workOrderLogList == "") {
            //不知道为啥赋值 先隐藏
            // res.product.status === 3
            //   ? (res.isUnderWarranty = 1)
            //   : (res.isUnderWarranty = 0);
            // console.log(
            //   res.product.status,
            //   res.isUnderWarranty,
            //   "res.product.status, res.isUnderWarranty"
            // );
            res.handlerId = "";
            res.schemeList[0].workOrderLogList = [
              {
                id: "",
                createTime: "",
                handleType: "",
                handlerId: "",
                isAdmin: "",
                isView: "",
                replyContent: "",
                schemeId: "",
                workOrderId: "",
                partsOrder: {
                  accessoryInfoList: [],
                  partsOrderLogList: [],
                },
                expatriateOrder: {
                  serviceInvitation: {
                    fileName: "",
                    accessoryUrl: "",
                  },
                },
              },
            ];
          }
          if (!res.machine) {
            res.machine = {
              machineModel: "",
              machineAbbr: "",
              fiCom: "",
            };
          }
          //这块的兼容是为了详情的时候 没有关联问题来源跟故障分类的空对象情况
          if (!res.malfunctionAttribute) {
            res.malfunctionAttribute = {
              name: "",
            };
          }
          if (!res.problemAttribute) {
            res.problemAttribute = {
              name: "",
            };
          }
          //----------------------------------------
          //这块是为兼容没有关联配件跟外派服务的空对象情况
          if (!res.schemeList[0].workOrderLogList[0].partsOrder) {
            res.schemeList[0].workOrderLogList[0].partsOrder = {
              accessoryInfoList: [],
              adminId: 1,
              createTime: "",
              deliveryLogList: [],
              handlerId: 0,
              handlerName: "",
              id: "",
              isCheck: 0,
              isConfirm: 0,
              partsNum: 0,
              partsOrderLogList: [],
              partsOrderName: "",
              payment: "",
              sendProblemParts: 0,
              status: 0,
              workOrder: null,
            };
          }
          if (!res.schemeList[0].workOrderLogList[0].expatriateOrder) {
            res.schemeList[0].workOrderLogList[0].expatriateOrder = {
              adminId: 1,
              createTime: "",
              endTime: null,
              feeType: 1,
              handlerId: "",
              id: "",
              isAudit: 0,
              isCheck: 0,
              isConfirm: 0,
              peopleNum: 0,
              startTime: null,
              status: 0,
              workHour: 0,
              workOrder: null,
              serviceInvitation: {
                fileName: "",
                accessoryUrl: "",
              },
            };
          }
          //------------------------------------------
          if (res.schemeList[0].expatriateOrderStatus === 5) {
            res.schemeList[0].productFee.partsFee =
              res.schemeList[0].productFee.partsFee / 100;
            res.schemeList[0].productFee.trafficFee =
              res.schemeList[0].productFee.trafficFee / 100;
            res.schemeList[0].productFee.accommodationFee =
              res.schemeList[0].productFee.accommodationFee / 100;
            res.schemeList[0].productFee.serviceFee =
              res.schemeList[0].productFee.serviceFee / 100;
          }

          this.orderData = res;
          console.log(this.orderData, "aaaaaa");
          this.cardConfig.customerName = res.customer.customerName;
          this.cardConfig.englishName = res.customer.englishName;
          this.cardConfig.image = res.customer.imageUrl;
          this.cardConfig.customerId = res.customer.id;
          res.schemeList[0].workOrderLogList[0].partsOrder.sendProblemParts == 1
            ? (this.handleData.sendProblemParts = true)
            : (this.handleData.sendProblemParts = false);

          if (
            res.schemeList[0].workOrderLogList[0].handleType == 1 ||
            res.schemeList[0].workOrderLogList[0].handleType == 3
          ) {
            this.handleData.isParts = true;
          }
          if (
            res.schemeList[0].workOrderLogList[0].handleType == 2 ||
            res.schemeList[0].workOrderLogList[0].handleType == 3
          ) {
            this.handleData.isExpatriate = true;
          }
          // if(!this.isHandle){
          //     this.handleData.replyContent = res.replyContent;
          this.handleData.replyContent = res.schemeList[0].temporaryContent;
          // }
          this.handleData.notConfirm = res.schemeList[0].notConfirm === 1;
          for (let i in this.cardConfig.formLists) {
            if (
              this.cardConfig.formLists[i].key &&
              this.cardConfig.formLists[i].key.length > 0
            ) {
              this.cardConfig.formLists[i].value =
                res.customer[this.cardConfig.formLists[i].key];
            }
            if (this.cardConfig.formLists[i].key === "discount") {
              this.cardConfig.formLists[i].value /= 10;
            }
          }

          this.handleData.problemId = res.problemId;
          this.handleData.malfunctionId = res.malfunctionId;
          this.postForm.accessoryInfoList = res.accessoryInfoList;
          this.postForm.jobId = res.jobId;
          this.lastOrder = JSON.stringify(res); //用于解决编辑后取消 的对象复制问题
          this.getContact();
          this.getPrincipal();
          this.getHistoryMsg();
          this.totalFeeFun();
          // console.log(res)
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    //获取工单状态 --- 常量
    // getOderStatus() {
    //     let data = {
    //         code: "orderStatus",
    //     }
    //     this.ccRequest.do("admin/dict/pageTree", data, "GET").then(res => {
    //         this.orderStatus = res.rows[0].children;
    //         console.log(res)
    //     })
    // },
    //获取工单历史沟通记录
    getHistoryMsg() {
      let data = {
        workOrderId: this.orderData.schemeList[0].workOrderId,
        // schemeId: this.orderData.schemeList[0].id,
        pageSize: 999,
      };
      this.ccRequest
        .do("admin/fsb/work/order/log/query", data, "GET")
        .then((res) => {
          this.historyData = res.rows;
          console.log(res, "history");
        });
    },
    getEngineerData(api = false) {
      if (!api) {
        api = `admin/fsb/work/order/queryRoleSameUserList?roleTips=engineer&pageSize=999&isAsc=true`;
      }
      this.ccRequest.do(api, {}, "GET").then((res) => {
        this.engineerSelectorList = res.rows;
        // console.log(res, "admin/fsb/work/order/queryRoleSameUserList?roleTips=engineer&pageSize=999&isAsc=true");
      });
    },
    getUserData() {
      this.ccRequest.do("validate", {}, "GET").then((res) => {
        this.userData = res;
        this.getOrderData();
        if (res.roleTips == "accessoriesSpecialist") {
          // this.machineSelectorConfig.isDisable = true;// 暫時隱藏
          this.malfunctionSelectorConfig.isDisable = true;
          this.problemSelectorConfig.isDisable = true;
        }
      });
    },
    getData() {
      this.getUserData();

      // this.getOderStatus();
    },
  },
  mounted() {
    if (this.isCreate) {
      this.cardConfig.isOrderEdit = true;
      this.cardConfig.isOrderCreate = true;
      return false;
    }

    if (this.isDialog) {
      this.orderId = this.orderIdV2;
    } else if (this.$route.query.id) {
      this.orderId = this.$route.query.id;
    } else {
      if (this.$prevRouter.name == "OrderCreate") {
        this.$router.push({
          name: "OrderList",
        });
      } else {
        this.$router.go(-1);
      }
    }

    if (this.isDialog) {
      this.isHandle = this.isHandleV2;
    } else if (this.$route.query.isHandle) {
      this.isHandle = true;
    } else {
      // this.machineSelectorConfig.isDisable = true; 暫時隱藏
      this.malfunctionSelectorConfig.isDisable = true;
      this.handlerSelectorConfig.isDisable = true;
      this.problemSelectorConfig.isDisable = true;
    }
    // this.getInviteFile();
    this.getData();
    this.getTabText();
  },
  components: {
    UserCard,
  },
};
</script>

<style lang="scss">
/*.el-scrollbar__wrap{*/
/*    overflow-x: hidden !important;*/
/*}*/
.order-upload-image {
  position: relative;
  border: none !important;

  .dottedUpload {
    min-width: 100%;
    border: none;
  }
}
.html-context img {
  max-width: 400px;
}
</style>
<style scoped lang="scss">
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.font-color-success {
  color: #67c23a;
}
.edit-parts {
  > div {
    justify-content: flex-start;
    margin-bottom: 20px;
    span {
      width: 60px;
      margin-right: 10px;
      text-align: right;
    }
  }
}
.order {
  .table-box {
    background: #ffffff;
    margin-top: 20px;

    .table-title {
      padding: 10px 20px;

      .left {
        display: flex;
        align-items: center;

        .add-contacts {
          font-size: 12px;
          padding: 5px;
          margin-left: 15px;
        }
      }

      .show-btn {
        font-size: 12px;
        background: #e4e4e4;
        padding: 3px 10px;
        cursor: pointer;
      }
    }
  }
}

.order-content {
  margin-top: 20px;
  background: #ffffff;
  padding: 20px;

  .content-top {
    .excelData {
      margin-bottom: 15px;
      position: relative;

      > * {
        flex: 0 25%;
      }

      .btn-group {
        position: absolute;
        right: 0;
        top: 0;
        justify-content: flex-end;
      }

      /*&:nth-child(2){*/
      /*    >p:last-child{*/
      /*        flex: 1;*/
      /*        margin-left: 380px;*/
      /*    }*/
      /*}*/
      /*&:last-child{*/
      /*    max-width: 81.5%;*/
      /*}*/
    }
  }

  .content-bottom {
    margin-top: 20px;

    .left {
      > div {
        display: flex;

        &:last-child {
          margin-top: 20px;
        }

        > div {
          margin-left: 10px;
          flex: 1;
        }
      }
    }

    .right {
      display: flex;

      .image-lists {
        flex: 1;
        justify-content: flex-start;
        flex-wrap: wrap;

        .list {
          width: 80px;
          height: 80px;
          cursor: pointer;
          margin-left: 10px;
          border-radius: 5px;
          position: relative;
          .del-image {
            width: 20px;
            height: 20px;
            line-height: 0;
            justify-content: center;
            position: absolute;
            right: 0;
            top: 0;
            border: 1px solid #f00;
            color: #f00;
            font-size: 14px;
            border-radius: 50%;
            transform: translateX(50%) translateY(-50%);
            cursor: pointer;
          }
          img {
            width: 100%;
            display: block;
          }

          margin-bottom: 20px;
          border: 1px dotted #ccc;
        }
      }
    }
  }
}

.create-btn {
  border-top: 1px dotted #ccc;
  justify-content: center;
  padding: 15px 0;
  padding-bottom: 0;
  background: #ffffff;
  flex-wrap: wrap;

  .history-msg {
    p {
      color: #1ab394;
    }

    width: 100%;
    padding: 15px;
    padding-top: 0;
    border-bottom: 1px dotted #ccc;
  }

  .history-lists {
    width: 100%;
    padding: 15px;
    padding-top: 0;
    color: #6f6f6f;

    .list-border {
      border-left: 1px solid #e4e4e4;
      max-width: 80%;
    }

    .list {
      position: relative;
      display: flex;
      margin-top: 15px;
      padding: 0 15px;

      > *:not(.msg-context) {
        margin-top: 12px;
      }

      .left-icon {
        width: 10px;
        position: absolute;
        left: 0;
        top: 0;
        transform: translateX(-50%) translateY(50%);
        height: 10px;
        background: #e4e4e4;
        border-radius: 50%;
      }

      .user-msg {
        margin-left: 10px;
        line-height: 16px;
      }

      .msg-context {
        flex: 1;
        margin-left: 10px;
        border: 1px solid #e4e4e4;
        padding: 10px;
        font-size: 12px;

        .title-text {
          color: #282828;
          font-size: 14px;
        }

        .text,
        .text-list {
          margin-top: 3px;
        }

        .top {
        }

        .bottom {
          margin-top: 15px;
          max-width: 40%;
          align-items: flex-start;

          & > * {
            flex: 0 45%;
          }

          .left,
          .right {
            height: 100%;
          }

          .text-list {
          }
        }
      }
    }
  }
}

.order-solution {
  background: #ffffff;
  margin-top: 5px;

  .os-list {
    padding: 20px;
    border-bottom: 1px dotted #ccc;
    border-top: 5px solid #f3f3f4;
    .os-title {
      .left {
        justify-content: flex-start;

        > * {
          margin-left: 80px;
        }

        .title-control {
          padding: 0px;
          border-radius: 5px;
          border: 1px solid #e4e4e4;
          width: 24px;
          height: 24px;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
          margin-left: 0;
          & ~ .title {
            font-weight: bolder;
            color: #6f6f6f;
            width: 200px;
          }
        }

        .title {
          font-size: 18px;
          margin-left: 20px;
        }
      }
    }

    .select-box {
      margin-top: 20px;

      > div {
        margin-right: 20px;
        max-width: 150px;
      }
    }

    .os-content {
      .os-con-list {
        padding-top: 20px;

        .title {
          font-size: 16px;
        }

        &.machine-order {
          border-top: 1px dotted #e4e4e4;
          margin-top: 20px;
          .title {
            .btn-add-machine {
              margin-left: 15px;
            }

            .btn-need {
              margin-left: 65px;
            }
          }
        }

        .total-context {
          justify-content: flex-end;
          margin-top: 15px;

          > div {
            margin-left: 80px;

            > span {
              margin-left: 10px;
            }

            &.file-upload {
              span {
                margin-right: 20px;
              }
            }
          }
        }
        .download-file {
          text-decoration: underline;
          cursor: pointer;
          &:hover {
            color: #1ab394;
          }
        }
        &.expatriate-context {
          justify-content: flex-start;
          p {
            display: flex;
            align-items: center;
            margin-right: 45px;

            span {
              max-width: 50px;
              margin: 0 10px;
            }
          }
        }
        &.submit-btn {
          margin-top: 20px;
          border-top: 1px dotted #e4e4e4;
          padding: 20px;
        }
      }
      &.order-verify {
        .os-con-list {
          p {
            &:not(:first-child) {
              margin-left: 60px;
            }
            > span {
              max-width: 80px;
            }
          }
        }
      }
      .engineer-remark {
        align-items: flex-start;

        .remark-lists {
          flex: 1;
          margin: 0 10px;
          color: #6e6e6e;

          .list {
            margin-bottom: 5px;
          }
        }
      }

      .switch-btn {
        justify-content: flex-start;
        align-items: flex-end;

        > .title {
          margin-right: 15px;
          margin-bottom: 2px;
        }
      }
    }
  }
}

.params-input {
  justify-content: flex-start;

  > * {
    margin-right: 20px;
    max-width: 200px;
  }
}
</style>
